import { UrlApi } from "../../../../services/apirest";

// Trae los tipos de cliente de envasado (usados como "categoría" en el listado)
// para poblar el filtro. Reutiliza el endpoint ya existente /tipoclienteenvasado.
export const obtenerTiposCliente = async () => {
  const response = await fetch(`${UrlApi}/tipoclienteenvasado`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });

  if (!response.ok) {
    throw new Error("No se pudieron obtener los tipos de cliente");
  }

  return response.json();
};

// Pide el Excel (.xlsx) al backend y dispara la descarga en el navegador.
// El endpoint devuelve el archivo directamente (Content-Disposition: attachment),
// por eso se lee como blob en vez de json.
export const descargarListadoClientesCsv = async ({
  sucursalId,
  desde,
  hasta,
  tiposCliente = [],
  ordenPor,
  ordenDir,
}) => {
  const params = new URLSearchParams({ id_sucursal: sucursalId, desde, hasta });
  if (tiposCliente.length > 0) params.set("id_tipocliente", tiposCliente.join(","));
  if (ordenPor) params.set("orden_por", ordenPor);
  if (ordenDir) params.set("orden_dir", ordenDir);

  const url = `${UrlApi}/envasado_listado_clientes?${params.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });

  if (!response.ok) {
    let mensaje = `Error ${response.status} al generar el reporte`;
    try {
      const data = await response.json();
      if (data && data.error) mensaje = data.error;
    } catch {
      // el backend no devolvió JSON en este error, se deja el mensaje genérico
    }
    throw new Error(mensaje);
  }

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const enlace = document.createElement("a");
  enlace.href = objectUrl;
  enlace.download = `listado_clientes_kilos_${desde}_${hasta}.xlsx`;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  window.URL.revokeObjectURL(objectUrl);
};
